<template>
  <div class="home">
    <v-row justify="center" class="mt-3">
      <v-img :src="imagen" contain height="200" />
    </v-row>
  </div>
</template>

<script>
import { decode } from 'js-base64';

export default {
  name: 'Home',
  data() {
    return {
      imagen: '',
    };
  },

  created() {
    this.getLogo();
  },

  methods: {
    async getLogo() {
      const logo = localStorage.getItem('logo');
      this.imagen = logo ? decode(logo) : '';
    },
  },
};
</script>
